import { Reveal } from "../components/site/Motion";
import { SectionLabel } from "../components/site/Bits";

// Shared layout for Privacy Policy and Terms pages.
export default function LegalLayout({ label, title, updated, children, testid }) {
  return (
    <main data-testid={testid} className="bg-background pt-28">
      <section className="relative overflow-hidden border-b border-slate-200">
        <div className="mesh-glow pointer-events-none absolute inset-0" />
        <div className="relative mx-auto max-w-4xl px-5 py-16 lg:px-8">
          <Reveal>
            <SectionLabel>{label}</SectionLabel>
            <h1 className="mt-5 font-display text-4xl font-extrabold leading-tight tracking-tighter text-ink sm:text-5xl">
              {title}
            </h1>
            <p className="mt-4 text-sm text-slate-500">Last updated: {updated}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-5 py-16 lg:px-8">
        <article className="legal-prose space-y-8 text-[15px] leading-relaxed text-slate-700">
          {children}
        </article>
      </section>
    </main>
  );
}

export const LegalBlock = ({ heading, children, num }) => (
  <div>
    <h2 className="font-display text-xl font-bold text-ink">
      {num ? <span className="mr-2 text-brand">{num}.</span> : null}
      {heading}
    </h2>
    <div className="mt-3 space-y-3 text-slate-600">{children}</div>
  </div>
);
